import React from 'react';
import { 
  ExpandLess,
  ExpandMore
} from '@mui/icons-material';

interface Props {
  is_expanded?: boolean;
  disabled?: boolean;
  label?: string;
  onClick: () => void;
}

export default function ExpandButton({ 
  is_expanded = false,
  disabled = false,
  label = "",
  onClick 
}: Props) {

  if (label === "") {
    return (
      <span className="clickable"
        onClick={() => {
          if (!disabled) {
            onClick();
          }
        }}>
        { is_expanded ? 
          <ExpandLess/>
        : 
          <ExpandMore/>
        }
      </span>
    );
  } else {
    return (
      <span className="clickable"
        onClick={() => {
          if (!disabled) {
            onClick();
          }
        }}>
        { is_expanded ? 
          <ExpandLess/>
        : 
          <ExpandMore/>
        }&nbsp;{ label }
      </span>
    );
  }
}
